<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    :before-close="closeModal">

     <el-tabs class="mt-0" v-model="activeTab" @tab-click="handleClick">
        <el-tab-pane label="Profile" name="Profile">
          <br>
          <div class="row">
            <fg-input class="col-md-6" type="text"
                label="First Name"
                id="affiliate-focus"
                placeholder="First Name"
                v-model="firstName"
                :disabled="archived"
                @keyup.enter="saveAffiliate()"
                ref="tofocus"/>
            <fg-input class="col-md-6" type="text"
              label="Last Name"
              placeholder="Last Name"
              v-model="lastName"
              :disabled="archived"
              @keyup.enter="saveAffiliate()"/>
          </div>
          <fg-input type="text"
              label="Position"
              placeholder="Position"
              v-model="position"
              :disabled="archived"
              @keyup.enter="saveAffiliate()"/>
          <fg-input type="text"
              label="Email"
              placeholder="Email"
              v-model="email2"
              :disabled="archived"
              @keyup.enter="saveAffiliate()"/>
              
          <fg-input v-if="archived"
              type="text"
              label="Company"
              placeholder="Company"
              :value="$store.getters.companies.find(elem => elem.id == affiliateCompanyId) ? 
                        $store.getters.companies.find(elem => elem.id == affiliateCompanyId).name : 0"
              disabled/>
          <fg-input v-else
              label="Company">
            <el-select class="select-transparent removeReadonly" v-model="affiliateCompanyId" :filterable="false">
              <el-option v-for="item in $store.getters.companies"
                    :value="item.id"
                    :label="item.profile.companyName"
                    :key="item.id"/>
            </el-select>
          </fg-input>
        </el-tab-pane>
        <el-tab-pane v-if="modalState.mode != 'Create'" label="Payouts" name="Payouts">
          <Payouts-Table :forAffiliate="affiliate" hideAddPayout/>
        </el-tab-pane>
      </el-tabs>

    

    <span slot="footer" class="dialog-footer">
      <div class="row">
        <span v-if="modalState.mode != 'Create'" class="col-1">
          <!-- <button v-if="deletable" class="btn btn-danger" @click="deleteAffiliate()">Delete</button> -->
          <!-- <button v-else-if="archived" class="btn" @click="toggleArchive()">Unarchive</button> -->
          <!-- <button v-else class="btn" @click="toggleArchive()">Archive</button> -->
          <!-- <button v-else class="btn" @click="test">Archive</button> -->
        </span>

        <span class="ml-auto col-4">
          <button class="btn" @click="closeModal()">Close</button>&nbsp;
          <!-- <button class="btn" @click="closeModal()">Cancel</button>&nbsp; -->
          <!-- <button class="btn btn-success" @click="saveAffiliate()">{{buttonLabel}}</button> -->
        </span>
      </div>
    </span>
  </el-dialog>
</template>

<script>
import {Affiliate, AffiliateCompanyProxy} from 'src/classes/datamodel.js'
export default {
  name: 'Affiliate-Modal',
  data () {
    return {
      activeTab: 'Profile'
    }
  },
  computed: {
    modalState () {
      return this.$store.getters.modal
    },
    title () {
      // return this.modalState.mode + ' Affiliate'
      return 'Affiliate'
    },
    visible () {
      return this.$store.state.modal.current == 'Affiliate'
    },
    affiliate () {
      return this.modalState.object || {}
    },
    buttonLabel () {
      return this.modalState.mode == 'Create' ? 'Create' : 'Save'
    },
    archived: { get()  { return this.affiliate.archived; },
                set(archived) { this.affiliate.archived = archived }
    },
    firstName: { get() { return this.affiliate.firstName; },
            set(firstName)    { this.affiliate.firstName = firstName }
    },
    lastName: { get() { return this.affiliate.lastName; },
            set(lastName)    { this.affiliate.lastName = lastName }
    },
    email2: { get() { return this.affiliate.email2 },
             set(email2)   { this.affiliate.email2 = email2 }
    },
    position: { get()  { return this.affiliate.position },
                set(position) { this.affiliate.position = position }
    },
    affiliateCompanyId: { get()            { return this.affiliate.affiliateCompanyId || (this.modalState.mode == 'Create'
                                                                                          && this.$store.getters.companySelected != 0
                                                                                           ? this.$store.getters.companySelected : undefined) },
                          set(affiliateCompanyId) { this.affiliate.affiliateCompanyId = affiliateCompanyId }
    },
    deletable: { get()   { return this.affiliate.deletable },
                 set(deletable) { this.affiliate.deletable = deletable }
    }
  },
  methods: {
    closeModal () {
      this.$store.dispatch('closeModal')
      // we hide any edit input field (for manual payouts) that would still be open
      // (otherwise they'll appear in the next Payout table...)
      $('.toHideWhenClosing').each(function() {
        $(this).addClass('d-none')
      })
      // and show the normmal divs back
      $('.toShowWhenClosing').each(function() {
        $(this).removeClass('d-none')
      })
      setTimeout(() => { // We wait till the modal disapears completely and then reset the tab
        this.activeTab = 'Profile'
      }, 500); 
    },
    toggleArchive () {
      this.archived = !this.archived
    },
    async saveAffiliate () {
      return
      var mode = this.$store.state.modal.mode
      const res = await this.$store.dispatch(mode=='Edit'?'updateRestObject':'createRestObject', new AffiliateProxy(this.affiliate))
      if (res.errors) {
          if (!res.errors[0] || typeof res.errors[0] != 'string' || !res.errors[0].toLowerCase().includes('session')) { // we don't show the error because the API service is rerouting to login page
          this.$notify({ errorMessage: res.errors[0] })
        }
      }
      else { this.$notify({ successMessage: 'Saved!'})
             this.closeModal()
      }
    },
    handleClick(tab, event) {
      //console.log(tab, event)
    }
  },
  mounted () {
    // $('#affiliate-focus').focus()
    // document.getElementById('affiliate-focus').focus()
    // $('#affiliate-focus').attr('autofocus', true)
  },
  watch: {
    visible: function (elem) {
      if (this.visible) {
        // doesn't work without the timeout..
        return
        if (this.$refs.tofocus) {
          setTimeout(() => this.$refs.tofocus.$el.children[1].focus(), 500)
        }
      }
    }
  }
}
</script>

<style>

</style>